export const DENSE_TABLE_CONTAINER_CLASS = 'overflow-x-auto rounded-[12px] bg-surface-sunken';

export const DENSE_TABLE_HEADER_CLASS = '[&_tr]:border-b-0';

export const DENSE_TABLE_HEADER_ROW_CLASS = 'border-b-0 hover:bg-transparent';

export const DENSE_TABLE_ROW_CLASS = 'border-b-0 hover:bg-foreground/[0.04]';

export const DENSE_TABLE_HEAD_CLASS =
  'h-7 px-3 text-[11px] font-medium uppercase tracking-wide text-muted-foreground';

export const DENSE_TABLE_CELL_CLASS = 'px-3 py-1.5 text-sm';

export const DENSE_TABLE_STICKY_BG_CLASS = 'bg-surface-sunken';

export const DENSE_TABLE_SORT_BUTTON_CLASS =
  '-ml-2 h-7 px-2 text-[11px] font-medium uppercase tracking-wide text-muted-foreground hover:bg-transparent';
